export default __webpack_public_path__ + "static/media/prescription.5dec0b23.svg";